import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Layout } from './components/Layout';
import { Overview } from './pages/Overview';
import { SiteManagement } from './pages/SiteManagement';
import { CapacityAnalysis } from './pages/CapacityAnalysis';
import { FrequencyAnalysis } from './pages/FrequencyAnalysis';
import { EquipmentAnalysis } from './pages/EquipmentAnalysis';
import { StatusMonitoring } from './pages/StatusMonitoring';
import LinkRoute from './pages/LinkRoute';
export function App() {
  return <AuthProvider data-id="element-0" data-mp="2wka0gqyiyz29">
      <BrowserRouter data-id="element-1" data-mp="2wjqff1dkvuk0">
        <Routes data-id="element-2" data-mp="2wiff5bjcd4xn">
          {/* PUBLIC */}
          <Route path="/login" element={<Login data-id="element-4" data-mp="28tmdqzjya4vn" />} data-id="element-3" data-mp="28ufnm9e7hai0" />

          {/* PROTECTED */}
          <Route path="/" element={<ProtectedRoute data-id="element-6" data-mp="23ujk0b9f7l2z">
                <Layout data-id="element-7" data-mp="23t8g8bfz6dbv" />
              </ProtectedRoute>} data-id="element-5" data-mp="28sbend1g9lav">
            <Route index element={<Overview data-id="element-9" data-mp="3ihuyk4ft23e4" />} data-id="element-8" data-mp="3ijfu9xduvsdk" />
            <Route path="sites" element={<SiteManagement data-id="element-11" data-mp="3mkho1yp07c85" />} data-id="element-10" data-mp="3mlaxj7fckftz" />
            <Route path="capacity" element={<CapacityAnalysis data-id="element-13" data-mp="3rcj6k2crlz6m" />} data-id="element-12" data-mp="3mjg9hk8s47lo" />
            <Route path="frequency" element={<FrequencyAnalysis data-id="element-15" data-mp="3recedkz46pg7" />} data-id="element-14" data-mp="3rdki07xp0nov" />
            <Route path="equipment" element={<EquipmentAnalysis data-id="element-17" data-mp="4n5w26l2pak" />} data-id="element-16" data-mp="6hqffdy0fe4" />
            <Route path="status" element={<StatusMonitoring data-id="element-19" data-mp="2zlle8zeb8glo" />} data-id="element-18" data-mp="7suzhf7pr6a" />
            <Route path="linkroute" element={<LinkRoute data-id="element-21" data-mp="2zng0qi58cgrv" />} data-id="element-20" data-mp="2zmem63p09c5e" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}